import { useState } from "react";

const useModal = () => {
  const [isShowing, setIsShowing] = useState(false);

  function toggle(val?: boolean) {
    if (typeof val === "boolean") {
      setIsShowing(val);
      return;
    }
    // If an event (e.g., onClick) is passed, treat it as a toggle
    setIsShowing((prev) => !prev);
  }

  return {
    isShowing,
    toggle,
  };
};

export default useModal;
